import React, { useState } from 'react';
import styled from 'styled-components';
import {MainLayout, InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactItem from '../Components/ContactItem';


   


function ContactPage() {
    const phone = <PhoneIcon />
    const email = <EmailIcon />
    const location = <LocationOnIcon />

    const [user, setUser]= useState({
        name: "",
        email: "",
        address: "",
        textarea: "",
     });

     let name, value;
     const getUserData = (event) =>{
         name=event.target.name;
         value= event.target.value;

         setUser({ ...user, [name]: value});
     };

     const postData = async (e)=>{
        e.preventDefault();

        const {name, email, address, textarea } = user;
        
        if(name && email && address&& textarea) {
              
       

       const res = await fetch("https://tsf-sawraj-default-rtdb.firebaseio.com/TSFContact.json", 
       {
           method: "POST",
           headers: {
               "Content-Type": "application/json",
           },
           body: JSON.stringify({
            name,
            email, 
            address, 
            textarea, 
           }),
       }
    );
    if(res){
        setUser({
        name: "",
        email: "",
        address: "",
        textarea: "",
        });
        alert("Data Stored Successfully");
       }
        
     } else {
           alert("Please Fill the Data");
       }
     };

    return (
        <MainLayout>
            <Title title={'Contact'} />
            <ContactPageStyled >
            <InnerLayout className={'contact-section'}>
                <div className="left-content">
                    <div className="contact-title">
                        <h4>Get In Touch</h4>
                    </div>
                    <form  className="form" method="POST">
                        <div className="form-field">
                            <label htmlFor="name"  >Enter your name*</label>
                            <input value={user.name} onChange={getUserData} type="text" name="name" id="name" required />
                        </div>
                        <div className="form-field">
                            <label htmlFor="email"  >Enter your email*</label>
                            <input value={user.email} onChange={getUserData} type="email" name="email" id="email" required/>
                        </div>
                        <div className="form-field">
                            <label htmlFor="Address"  >Enter your Address</label>
                            <input value={user.address} onChange={getUserData} type="text" name="address" id="subject" />
                        </div>
                        <div className="form-field">
                            <label htmlFor="text-area">Enter your Message*</label>
                            <textarea value={user.textarea} onChange={getUserData} name="textarea"  id="textarea" cols="30" rows="10"></textarea>
                        </div>
                        
                        <button className="form-field f-button" onClick={postData}>Send</button>
                    </form>
                </div>
                <div className="right-content">
                    <ContactItem title={'Phone'} icon={phone} cont1={'+91 91xxxxxxxx'}  />
                    <ContactItem title={'Email'} icon={email} cont1={'Alpha.sawraj@gmail.com'}  />
                    <ContactItem title={'Address'} icon={location} cont1={'Noida, Uttar-Pradesh'} cont2={'India'} />
                    
                </div>
            </InnerLayout>
            </ContactPageStyled>
        </MainLayout>
    )
}

const ContactPageStyled = styled.section`
    .contact-section{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2rem;
        @media screen and (max-width: 978px){
            grid-template-columns: repeat(1, 1fr);
            .f-button{
                margin-bottom: 3rem;
            }
        }
        .right-content{
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            @media screen and (max-width: 502px){
                width: 70%;
            }
        }
        .contact-title{
            h4{
                color: var(--white-color);
                padding: 1rem 0;
                font-size: 1.8rem;
            }
        }
        .form{
            width: 100%;
            @media screen and (max-width: 502px){
                width: 100%;
            }
            .form-field{
                margin-top: 2rem;
                position: relative;
                width: 100%;
                label{
                    position: absolute;
                    left: 20px;
                    top: -19px;
                    display: inline-block;
                    background-color: var(--background-dark-color);
                    padding:0 .5rem;
                    color: inherit;
                }
                input{
                    border: 1px solid var(--border-color);
                    outline: none;
                    background: transparent;
                    height: 50px;
                    padding:0 15px;
                    width: 100%;
                    color: inherit;
                }
                textarea{
                    background-color: transparent;
                    border: 1px solid var(--border-color);
                    outline: none;
                    color: inherit;
                    width: 100%;
                    padding: .8rem 1rem;
                }
            }

            
        }
    }
`;

export default ContactPage
